import { useEffect, useState } from "react";
import classes from './FeedbackAndGrade.module.css';
import * as SubmissionStatusEnum from "../../../../lms-shared/models/SubmissionStatus";
import { Tab, TabsMenu } from "../../../../UI/TabsMenu";
import Rejected from "./Rejected/Rejected";
import SummativeAssessment from "./SummativeAssessment/SummativeAssessment";
import { ObjectTypeNamesEnum } from "../../../../../models/ObjectTypeEnum";
import { useParams } from "react-router-dom";
import { messagesApi } from "../../../../../utils";
import { useDispatch, useSelector } from "react-redux";
import { throwApiError } from "../../../../lms-shared/store/error-handling-actions";
import { cretaeMessageContent } from "../../../../lms-shared/functions/Message";

const FeedbackAndGrade = ({ data, setData, nextAssessment, markAssessmentAsChecked }) => {

    const dispatch = useDispatch();
    let { id } = useParams();
    const { texts, direction } = useSelector(state => state.translate);
    const [editData, setEditData] = useState(false);
    const [dynamicIndicatorObj, setDynamicIndicatorObj] = useState()

    useEffect(() => {
        const getDynamicIndicatorObject = async () => {
            const res = await fetch(window.config.dynamicIndicatorTeacher);
            const resJson = await res.json();
            setDynamicIndicatorObj(resJson)
        }
        getDynamicIndicatorObject()
    }, [])

    useEffect(() => {
        if (data.submissionStatusId != SubmissionStatusEnum.rejected && data.submissionStatusId != SubmissionStatusEnum.completed)
            setEditData(true)
        else
            setEditData(false)
    }, [data])

    const handleNotification = (textHe, textAr, textEn) => {
        const link = `${id}/lesson/${data?.lessonId}`;
        const contents = cretaeMessageContent(textHe, textAr, textEn, link);
        const messageAddOrUpdateInput = {
            refObjectId: id,
            refObjectType: ObjectTypeNamesEnum.StudyGroup,
            targetObjectId: data?.submittedByUserId,
            targetObjectType: ObjectTypeNamesEnum.User,
            contents
        }
        messagesApi.messagesAddPost({ messageAddOrUpdateInput }, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.MessagePostError, error: error, statusCode: response?.statusCode, message: "messagesAddPost " + error.message, level: 1, component: "SummativeAssessment", line: 145 }))
            }
            else {
                console.log('message sent successfully!')
            }
        })
    }


    return (
        <div className={`${classes[direction]} ${classes.FeedbackAndGrade}`}>
            <div className={classes.TitleContainer}>
                <div className={classes.Title}>{texts.feedbackAndEvaluation}</div>
                <TabsMenu scrollContentHeight={"100%"} contentHeight={"100%"} dropClass={classes.TabsPlace} dropClassSelectedTab={classes.SelectedTab} menuDropClass={classes.MenuTabPlace} TabDropClass={classes.Tab} startTabIndex={data.submissionStatusId != SubmissionStatusEnum.rejected ? 0 : 1}  >
                    <Tab disabeled={!editData} name={texts.summativeAssessment}>
                        <SummativeAssessment submissionData={data} setSubmissionData={setData} dynamicIndicatorObj={dynamicIndicatorObj} nextAssessment={nextAssessment} markAssessmentAsChecked={markAssessmentAsChecked} editData={editData} setEditData={setEditData} handleNotification={handleNotification} />
                    </Tab>
                    <Tab disabeled={!editData} name={texts.returnForRepair}>
                        <Rejected submissionData={data} setSubmissionData={setData} dynamicIndicatorObj={dynamicIndicatorObj} nextAssessment={nextAssessment} markAssessmentAsChecked={markAssessmentAsChecked} editData={editData} setEditData={setEditData} handleNotification={handleNotification} />
                    </Tab>
                </TabsMenu>
            </div>
        </div>
    )
}
export default FeedbackAndGrade